import React, { useEffect, useState } from 'react'

//importing components
import Control from 'components/Control/Control'
import Date from 'components/Date/Date'
import Divider from 'components/Divider/Divider'
import AntdInput from 'components/Form/Input'
import Delete from 'components/icons/Delete'
import Dropdown from 'components/icons/Dropdown'
import Label from 'components/Label/Label'
import {
  Container,
  FormItem,
  Heading,
  IconView,
  SubHeading,
} from 'modules/Resume/DrawerComponents/EducationDetailStyle'
import moment from 'moment'
import FileReaderVisible from 'components/Uploader/FileReaderVisible'
import Uploadloader from 'components/Uploader/Uploader'
import RichEditor from 'components/RichEditor/index'

const AwardForm = ({
  form,
  formName,
  onRemove,
  studentFormData,
  setIsUpdateButtonEnabled,
  frozenFields = {},
}) => {
  const [show, setShow] = useState(true)
  const [projectTitle, setProjectTitle] = useState('')
  const [date, setDate] = useState(
    form.getFieldValue([[formName], 'awarded_on'])
  )
  const [timeLine, setTimeLine] = useState('')

  const [description, setDescription] = useState(
    form.getFieldValue([[formName], 'description'])
  )
 const [file, setFile] = useState(
  form.getFieldValue([[formName], 'certificate'])
)

  const onChangeDescription = data => {
    if (
      (description == undefined &&
        data
          ?.replace(/<[^>]*>/g, '')
          ?.replace(/&nbsp;/g, ' ')
          ?.trim('') > 0) ||
      description?.toString('html') !== data?.toString('html')
    ) {
      setIsUpdateButtonEnabled(false)
      form.setFieldsValue({ [formName]: { description: data } })
      setDescription(data)
    }
  }

  const onBlurProjectTitle = e => {
    form.setFieldsValue({ [formName]: { title: e.target.value } })
    setProjectTitle(e.target.value)
  }
  const showHandler = () => {
    show ? setShow(false) : setShow(true)
  }

  const onDateChange = (date, dateString) => {
    setIsUpdateButtonEnabled(false)
    form.setFieldsValue({ [formName]: { awarded_on: dateString } })
    setDate(dateString)
  }

  const getFormName = level => {
    let name = level.replaceAll('_', '')
    return name?.replace(/\d/g, '')
  }
  
  useEffect(() => {
  const cert = form.getFieldValue([[formName], 'certificate'])
    setFile(cert || null)
  }, [formName])

  // useEffect(() => {
  //   form.setFieldsValue({ [formName]: { certificate: file } })
  // }, [file])

  useEffect(() => {
    if (date) {
      setTimeLine(moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY'))
    }
  }, [date])

  const countRichTextCharacters = richText => {
    // Remove HTML tags using a regular expression
    const plainText = richText?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ')

    // Count the characters in the plain text
    const characterCount = plainText?.length || 0 // Set to 0 if undefined

    return characterCount
  }

  const handleInputChange = e => {
    setIsUpdateButtonEnabled(false)
  }

  return (
    <Container column flexStart>
      <Control spaceBetween alignCenter>
        <Control column flexStart>
          <Heading>{projectTitle || 'Title'}</Heading>
          <SubHeading>{timeLine || 'Timeline'}</SubHeading>
        </Control>
        <Control gap="10px" flexEnd>
          {!frozenFields.certificate && (
            <IconView onClick={() => onRemove(false, true, formName)}>
              <Delete />
            </IconView>
          )}
          <IconView onClick={() => showHandler()}>
            <Dropdown />
          </IconView>
        </Control>
      </Control>
      {show && (
        <>
          <Divider />
          <Control top="20px" flexStart column>
            <Label>Title *</Label>
            <AntdInput
              placeholder="Please Enter Title"
              name={[[formName], 'title']}
              maxLength={120}
              rules={[
                {
                  required: true,
                  min: 3,
                  max: 120,
                  message:
                    'Please enter Title name! Minimum 3 characters, Maximum 120 characters.',
                },
              ]}
              onBlur={onBlurProjectTitle}
              onChange={handleInputChange}
            />
          </Control>
          <Control top="20px" flexStart column>
            <Label>Institute/Organization *</Label>
            <AntdInput
              placeholder="Please Enter Organization Name"
              name={[[formName], 'organization']}
              maxLength={120}
              rules={[
                {
                  required: true,
                  min: 3,
                  max: 120,
                  message:
                    'Please enter Organization name! Minimum 3 characters, Maximum 120 characters.',
                },
              ]}
              onChange={handleInputChange}
            />
          </Control>

          <FormItem
            name={[[formName], 'awarded_on']}
            rules={[
              {
                required: true,
                message: 'Please provide Date!',
              },
            ]}
          >
            <Control flexStart top="20px" column>
              <Label>Date *</Label>
              <Date
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                defaultValue={
                  form.getFieldValue([[formName], 'awarded_on'])
                    ? moment(
                        form.getFieldValue([[formName], 'awarded_on']),
                        'DD/MM/YYYY'
                      )
                    : null
                }
                disabledDate={d => !d || d.isAfter(moment())}
                onChange={onDateChange}
              />
            </Control>
          </FormItem>

          <Control top="20px" flexStart column>
            <Label>Description *</Label>
            <FormItem
              name={[[formName], 'description']}
              rules={[
                {
                  validator: async (_, value) => {
                    if (countRichTextCharacters(value) > 1000) {
                      return Promise.reject(
                        new Error('Maximum 1000 Character allowed!')
                      )
                    }
                    if (countRichTextCharacters(value) === 0) {
                      return Promise.reject(new Error('Description Required!'))
                    }

                    return Promise.resolve()
                  },
                },
              ]}
            >
              <RichEditor value={description} onChange={onChangeDescription} />
            </FormItem>
            {'Characters: ' +
              countRichTextCharacters(
                form.getFieldValue([[formName], 'description'])
              ) +
              ' / 1000'}
          </Control>
          <Control flexStart column top="20px">
            <FormItem name={[[formName], 'certificate']} noStyle>
              <Label>Certificate</Label>

              {file ? (
                <Control column top="10px" center>
                  <FileReaderVisible
                    file={file}
                    setFile={(val) => {
                      setFile(val)
                      form.setFieldsValue({
                        [formName]: { certificate: val },
                      })
                      setIsUpdateButtonEnabled(false)
                    }}
                  />
                </Control>
              ) : (
                <Control column top="10px" center>
                  <Uploadloader
                    variant="simple"
                    label="Upload Certificate"
                    setFile={(uploadedFile) => {
                      setFile(uploadedFile)
                      setIsUpdateButtonEnabled(false)
                      form.setFieldsValue({
                        [formName]: { certificate: uploadedFile },
                      })
                    }}
                    fileName={`${studentFormData?.admin?.firstName
                      ?.toLowerCase()
                      ?.replace(/\s/g, '')}_${formName}_certificate`}
                    onlyDoc={false}
                  />
                </Control>
              )}
            </FormItem>
          </Control>
          {/* <Control flexStart column top="20px">
            <FormItem name={[[formName], 'certificate']}>
              <Label>Certificate </Label>
              {file && Object.keys(file)?.length > 0 ? (
                <Control column top="10px" center>
                  <FileReaderVisible
                    file={file}
                    setFile={setFile}
                    setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  />
                </Control>
              ) : (
                <Control column top="10px" center>
                  <Uploadloader
                    setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                    setFile={setFile}
                    isDefault={true}
                    fileName={
                      studentFormData?.admin?.firstName?.toLowerCase() +
                      '_' +
                      getFormName(formName) +
                      '_certificate'
                    }
                  />
                </Control>
              )}
            </FormItem>
          </Control> */}
        </>
      )}
    </Container>
  )
}

export default AwardForm
